import { render, staticRenderFns } from "./NutricionalDetallesPaciente.vue?vue&type=template&id=34c27f24"
import script from "./NutricionalDetallesPaciente.vue?vue&type=script&lang=js"
export * from "./NutricionalDetallesPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports